import { PREVIOUS_DIRECTION, PREVIOUS_DIRECTION_ICON, NEXT_DIRECTION_ICON } from './PaginatedArrow.constants';
export function getDirectionHandler(direction, _ref) {
  var next = _ref.next,
    previous = _ref.previous;
  return direction === PREVIOUS_DIRECTION ? previous : next;
}
export function getDefaultDirectionIcon(direction) {
  return direction === PREVIOUS_DIRECTION ? PREVIOUS_DIRECTION_ICON : NEXT_DIRECTION_ICON;
}